"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8590],{

/***/ 28590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_newsCard_newsTopbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4825);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96781);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31555);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _newsCard_ReadNewsCardNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43063);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);




 // import ReadNews from "components/newsCard/readNews";
// import GoogleAdContainer from "../adContainer/googleAdContainer";






var TopShowsWidget = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 4699).then(__webpack_require__.bind(__webpack_require__, 14699));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14699)];
    }
  }
});
var NewsImageTextBanner1 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6677), __webpack_require__.e(5312)]).then(__webpack_require__.bind(__webpack_require__, 36677));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36677)];
    }
  }
});

var FirstCategory = function FirstCategory(_ref) {
  var _newsData$slice, _newsData$slice2, _newsData$slice3, _newsData$slice4, _newsData$slice5;

  var categoryInfo = _ref.categoryInfo,
      newsData = _ref.newsData,
      topShowsWidgetData = _ref.topShowsWidgetData,
      topPodcastData = _ref.topPodcastData;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .iP)();
  console.log("categoryInfocategoryInfo", categoryInfo);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "outer-containers1",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "content-container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "content",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "news-card-box",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_newsCard_newsTopbar__WEBPACK_IMPORTED_MODULE_1__["default"], {
              newsEn: categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name,
              newsHn: (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.nameHn) || "",
              newsIcon: "",
              newsBgclassName: "bar-bg-1",
              categoryInfo: categoryInfo // horizontalPosts={categorizedNews.horizontalPosts}
              // restPosts={categorizedNews.restPosts}

            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "split-left-container",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                style: {},
                children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice = newsData.slice(0, 1)) === null || _newsData$slice === void 0 ? void 0 : _newsData$slice.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(NewsImageTextBanner1, {
                      postData: postData
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice2 = newsData.slice(1, 3)) === null || _newsData$slice2 === void 0 ? void 0 : _newsData$slice2.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  className: "featuredCards",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_newsCard_ReadNewsCardNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                style: {},
                children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice3 = newsData.slice(3, 4)) === null || _newsData$slice3 === void 0 ? void 0 : _newsData$slice3.map(function (postData) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(NewsImageTextBanner1, {
                      postData: postData
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice4 = newsData.slice(4, 6)) === null || _newsData$slice4 === void 0 ? void 0 : _newsData$slice4.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  className: "featuredCards",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_newsCard_ReadNewsCardNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "right-area-Col",
          style: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "news-card-box",
            children: size.width > 600 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "container-row py-2",
              align: "center",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                className: "container-row",
                align: "center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                  style: {
                    fontSize: "11px",
                    color: "#b7b7b7",
                    marginBottom: "0px"
                  },
                  children: "Advertisement"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  id: router.pathname === "/" ? "div-gpt-ad-1726480392574-0" : "div-gpt-ad-1701945220410-0",
                  style: {
                    minHeight: router.pathname === "/" ? "100px" : "260px",
                    alignContent: "center",
                    textAlign: "-webkit-center"
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
                    type: "text/javascript",
                    dangerouslySetInnerHTML: {
                      __html: router.pathname === "/" ? "\n                          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726480392574-0')})" : "\n                          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-0')})"
                    }
                  })
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "checkDesktopOrNot",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "line-newsImageTextBanner1",
              style: {
                height: "1px",
                background: "rgba(166, 166, 166, 0.2)",
                width: "100%",
                marginBottom: "1rem"
              }
            }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice5 = newsData.slice(6, 8)) === null || _newsData$slice5 === void 0 ? void 0 : _newsData$slice5.map(function (postData, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_newsCard_ReadNewsCardNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                  postData: postData,
                  isBanner: false
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            })]
          })]
        })]
      })
    }), (router.asPath.split("?")[0] === "/" || router.asPath.split("?")[0] === "/video") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(TopShowsWidget, {
      TopShowsWidgetData: topShowsWidgetData,
      topPodcastData: topPodcastData
    }), size.width > 500 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        id: size.width > 600 ? router.asPath.split("?")[0] === "/" ? "div-gpt-ad-1701945220410-2" : router.asPath.split("?")[0] === "/text" ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701945220410-2" : router.pathname === "/" ? "div-gpt-ad-1701946028239-2" : router.asPath.split("?")[0] === "/text" ? "div-gpt-ad-1701946028239-0" : "div-gpt-ad-1701946028239-1",
        style: {
          minWidth: "300px",
          minHeight: size.width > 600 ? "100px" : "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: size.width > 600 ? router.asPath.split("?")[0] === "/" ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-2')})" : router.asPath.split("?")[0] === "/text" ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})" : router.pathname === "/" ? "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-2')})\n              " : router.asPath.split("?")[0] === "/text" ? "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})\n              " : "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})\n              "
          }
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FirstCategory);

/***/ })

}]);